module.exports = __webpack_public_path__ + "img/coupon-default.8376ddcd.png";